import axios from "@/utils/axiosHelper";

// 初始化
export const onInitAPI = (params) => {
  return axios(
    { url: "/sword/book/old/index", method: "GET", params },
    { interceptResultCode: false }
  );
};

// 点击预约
export const onOldClickAPI = (params) => {
  return axios(
    { url: "/sword/book/old/click", method: "GET", params },
    { interceptResultCode: false }
  );
};

// 分享
export const onShareAPI = (params) => {
  return axios(
    { url: "/sword/book/old/share", method: "GET", params },
    { interceptResultCode: false }
  );
};

// 领取cdk
export const onCdkAPI = (params) => {
  return axios(
    { url: "/sword/book/old/cdk", method: "GET", params },
    { interceptResultCode: false }
  );
};

// 免密登录
export const onLoginAPI = (params) => {
  return axios(
    { url: "/game/login/free", method: "POST", params },
    { interceptResultCode: false }
  );
};

// 注销
export const onLogoutAPI = (params) => {
  return axios(
    { url: "/login/free/loginout", method: "POST", params },
    { interceptResultCode: false }
  );
};



// WEBPACK FOOTER //
// ./src/pages/hjwq/refluxCustomer/api.js